
// flatpickr = require('flatpickr')

// import '../../../public/css/flatpickr.css';


import Bugsnag from '@bugsnag/js'

Bugsnag.start({
	apiKey: bugsnagApi,
	releaseStage: environment,
	enabledReleaseStages: [ 'local', 'development','production', 'staging' ]
})

window.bugsnag = Bugsnag


new Vue({
	el: '#jsmenu',
	data: {
		hovered: false,
		toggled: false,
		destinations: vue_destinations,
		selectedDestination: vue_destinations[0]?vue_destinations[0]:''
	},
	methods: {
		lockDestination: function(destination){

			this.destinations = this.destinations.map(destination => {
				destination.selected = false
				return destination;
			});

			// var sd = this.destinations.filter(destination => destination.slug == 'slug')
			var sd = this.destinations.filter(item => item.slug == destination.slug)[0]

			sd.selected = true;
			this.selectDestination(destination)
		},
		selectDestination: function(destination){
			var selectedDestination = this.destinations.filter(destination => {
				return destination.selected == true;
			});

			if (selectedDestination.length) {
				this.selectedDestination = selectedDestination[0];
			} else {
				this.selectedDestination = destination;
			}
		},
		toggleMenu: function(){
			this.toggled = !this.toggled;
		},
		// toggleDestination: function (destination, e){
		// 	if (hasTouch) {
		// 		e.preventDefault();
		// 		this.selectedDestination = destination;
		// 	}
		// }
	},
	computed: {
		showMultimenu: function(){
			return window.screen.height >= 630&&(this.hovered||this.toggled);
		}
	}

})

window.onload = function () {
	var el = document.getElementById('termsbutton')
	if (el){
		el.addEventListener('click', function (event) {
			document.getElementById('terms').classList.remove('hide')
		})
	}

	let hideSliders = document.getElementsByClassName('hideslide')

	for (var i=0; i < hideSliders.length; i++) {
		if (hideSliders[i].clientHeight > 0){
			hideSliders[i].style.maxHeight = hideSliders[i].clientHeight+'px'
		}
	}

	let alertBanner = document.getElementById('AlertBanner')
	if (alertBanner){
		let head_el = document.getElementsByTagName('header')[0]
		let navbutton_el = document.getElementsByClassName('navbutton')[0]
		let alertHeight = alertBanner.clientHeight+'px'
		head_el.style.top = alertHeight
		navbutton_el.style.top = alertHeight

		alertBanner.getElementsByTagName('button')[0].addEventListener('click', () => {
			fetch('/api/setalertcookie')
			alertBanner.classList.add('closealert')
			head_el.removeAttribute('style')
			navbutton_el.removeAttribute('style')
			setTimeout(function () {
				alertBanner.remove()
			}, 300)
		})

	}

	if (userSession){
		let buttons = document.querySelectorAll('button')
		if (buttons){
			buttons.forEach( button => {
				button.addEventListener('click', (e) => {
					let name = e.target.name?e.target.name:'button'
					axios.post('/api/eventtrace', {value: name+': '+e.target.innerHTML+' '+e.target.title+' | '+window.location.href })
				})
			})
		}
	}
}



for (var i = 0; i < vue_destinations.length; i++) {
	(new Image()).src = vue_destinations[i].banner_image_webp
}

window.isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent)

Number.prototype.format = function(n, x, s, c) {
	var re = '\\d(?=(\\d{' + (x || 3) + '})+' + (n > 0 ? '\\D' : '$') + ')',
		num = this.toFixed(Math.max(0, ~~n))

	return (c ? num.replace('.', c) : num).replace(new RegExp(re, 'g'), '$&' + (s || ','));
}


